import { render, staticRenderFns } from "./Transform.vue?vue&type=template&id=a7b78630&scoped=true&"
import script from "./Transform.vue?vue&type=script&lang=js&"
export * from "./Transform.vue?vue&type=script&lang=js&"
import style0 from "./Transform.vue?vue&type=style&index=0&id=a7b78630&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7b78630",
  null
  
)

export default component.exports